
  <div class="modal-header">
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
    <div class="container-fluid">
        <div class="card">
          <div class="card-body row">
            <div class="col-6 d-flex align-items-center ">
              <h3 class="m-0">
                <span *ngIf="clientID">{{'GENERAL.EDIT' | translate}}</span>
                <span *ngIf="!clientID">{{'GENERAL.ADD' | translate}}</span>
                {{'GENERAL.CLIENT' | translate}}
              </h3>
            </div>
            <div class="col-6 d-flex justify-content-end ">
              <div class="text-center">
              <button class="btn btn-primary w-md" type="button" (click)="onSubmit();" [disabled]="clientsForm.invalid">
                  <i class="bx bx-loader bx-spin font-size-16 align-middle me-2" *ngIf="loadingclients"></i>
                  <span *ngIf="clientID">{{'GENERAL.EDIT' | translate}}</span>
                  <span *ngIf="!clientID">{{'GENERAL.ADD' | translate}} </span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <ng-container *ngIf="loadingShow && clientID">
          <div class="d-flex justify-content-center align-items-center" style="min-height: 300px;">
            <div class="spinner-border text-primary m-1" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="!loadingShow || !clientID">
          <form class="needs-validation py-3" [formGroup]="clientsForm">
            <div class="row">
              <div class="col-md-12">
                <div class="card p-2">
                  <div class="card-header text-center ">
                    {{'GENERAL.PERSONAL_INFORMATION' | translate}}
                  </div>
                  <!-- -------------------------------- Client Form  Details-------------------------------- -->
                  <div class="card-body row">
                    <div class="col-xl-4 col-lg-4">
                      <div class="mb-3">
                        <label for="validationCustom01" class="form-label text-capitalize">{{'GENERAL.NAME'
                          |
                          translate}} <!-- <span class="required">*</span> --> </label>
                        <input type="text" class="form-control" id="validationCustom01" formControlName="companyName"
                          [ngClass]="{'is-valid': form.companyName.dirty && !form.companyName.errors ,'is-invalid': form.companyName.dirty && form.companyName.errors}">
                        <div *ngIf="form.companyName.dirty && form.companyName.errors" class="invalid-feedback">
                          <span *ngIf="form.companyName.errors.required">This value is required.</span>
                        </div>
                      </div>
                    </div>
      
                    <div class="col-xl-4 col-lg-4">
                      <div class="mb-3">
                        <label for="validationCustom01" class="form-label text-capitalize">{{'GENERAL.TELEPHONE'
                          |
                          translate}} <span class="required">*</span></label>
                        <input type="text" class="form-control" id="validationCustom01" formControlName="phoneNumber"
                          [ngClass]="{'is-valid': form.phoneNumber.dirty && !form.phoneNumber.errors ,'is-invalid': form.phoneNumber.dirty && form.phoneNumber.errors}">
                        <div *ngIf="form.phoneNumber.dirty && form.phoneNumber.errors" class="invalid-feedback">
                          <span *ngIf="form.phoneNumber.errors.required">This
                            value is
                            required.</span>
                          <span *ngIf="form.phoneNumber.errors.pattern">This
                            value must be number</span>
                        </div>
                      </div>
                    </div>
      
                    <div class="col-xl-4 col-lg-4">
                      <div class="mb-3">
                        <label class="form-label text-capitalize">{{'GENERAL.EMAIL' | translate}}</label>
                        <div>
                          <input type="email" class="form-control" formControlName="email"
                            [ngClass]="{'is-valid': form.email.dirty && !form.email.errors ,'is-invalid': form.email.dirty && form.email.errors}" />
                          <div *ngIf="form.email.dirty && form.email.errors" class="invalid-feedback">
                            <span *ngIf="form.email.errors.required">This value is required.</span>
                            <span *ngIf="form.email.errors.email">This value should be a valid
                              email.</span>
                          </div>
                        </div>
                      </div>
                    </div>
      
                    <div class="col-xl-4 col-lg-4">
                      <div class="mb-3">
                        <label for="validationCustom01" class="form-label text-capitalize">{{'clients.commercialActivity' |
                          translate}}</label>
                        <input type="text" class="form-control" id="validationCustom01" formControlName="commercialActivity"
                          [ngClass]="{'is-valid': form.commercialActivity.dirty && !form.commercialActivity.errors ,'is-invalid': form.commercialActivity.dirty && form.commercialActivity.errors}">
                        <div *ngIf="form.commercialActivity.dirty && form.commercialActivity.errors" class="invalid-feedback">
                          <span *ngIf="form.commercialActivity.errors.required">This value is required.</span>
                        </div>
                      </div>
                    </div>
      
                    <div class="col-xl-4 col-lg-4">
                      <div class="mb-3">
                        <label for="validationCustom01" class="form-label text-capitalize">{{'GENERAL.IndustrySector' |
                          translate}} <!-- <span class="required">*</span> --></label>
                        <ng-select [items]="listOfIndustrySectors" class="form-control ng-select-customization"
                          (change)="GetAllIndustrySectorFields($event?.id)" formControlName="IndustrySector_Id"
                          bindLabel="name" bindValue="id"></ng-select>
                      </div>
                    </div>
      
                    <!-- ---------------------- Eng Ahmed Abdelhameed ------------------------ -->
                    <div class="col-xl-4 col-lg-4">
                      <div class="mb-3">
                        <label for="validationCustom01" class="form-label text-capitalize">{{'GENERAL.IndustrySectorFiled' |
                          translate}}</label>
                        <ng-select [items]="listOfIndustrySectorFiled" formControlName="IndustrySectorFiled_Id"
                          class="form-control ng-select-customization" bindLabel="name" bindValue="id"></ng-select>
                          <!-- <select class="form-select" formControlName="IndustrySectorFiled_Id">
                          <option [value]="item.id" *ngFor="let item of listOfIndustrySectorFiled">{{item.nameInArabic}}</option>
                        </select> -->
                      </div>
                    </div>
                    <!-- ---------------------------------------------------------------------- -->
      
                    <div class="col-xl-4 col-lg-4">
                      <div class="mb-3">
                        <label for="validationCustom01" class="form-label text-capitalize">{{'GENERAL.GENERALMANAGERNAME' |
                          translate}}</label>
                        <input type="text" class="form-control" id="validationCustom01" formControlName="generalManagerName"
                          [ngClass]="{'is-valid': form.generalManagerName.dirty && !form.generalManagerName.errors ,'is-invalid': form.generalManagerName.dirty && form.generalManagerName.errors}">
                        <div *ngIf="form.generalManagerName.dirty && form.generalManagerName.errors" class="invalid-feedback">
                          <span *ngIf="form.generalManagerName.errors.required">This value is
                            required.</span>
                        </div>
                      </div>
                    </div>
      
                  <!-- Eng Ahmed Abdelhameed Ali ---- this field deprecated -->
                    <!-- <div class="col-xl-4 col-lg-4">
                      <div class="mb-3">
                        <label for="validationCustom01" class="form-label text-capitalize">{{'GENERAL.SALESMANAGERNAME'
                          |
                          translate}}</label>
                        <input type="text" class="form-control" id="validationCustom01" formControlName="salesManagerName"
                          [ngClass]="{'is-valid': form.salesManagerName.dirty && !form.salesManagerName.errors ,'is-invalid': form.salesManagerName.dirty && form.salesManagerName.errors}">
                        <div *ngIf="form.salesManagerName.dirty && form.salesManagerName.errors" class="invalid-feedback">
                          <span *ngIf="form.salesManagerName.errors.required">This value is
                            required.</span>
                        </div>
                      </div>
                    </div> -->
      
                    <div class="col-xl-4 col-lg-4">
                      <div class="mb-3">
                        <label class="form-label text-capitalize">{{'GENERAL.FOLLOWINGTYPE' |
                          translate}}</label>
                        <ng-select class="form-control ng-select-customization"
                          [ngClass]="{'is-valid': form.clientType_Id.dirty && !form.clientType_Id.errors ,'is-invalid': form.clientType_Id.dirty && form.clientType_Id.errors}"
                          [items]="listOfClientTypes" formControlName="clientType_Id" bindLabel="name"
                          bindValue="id"></ng-select>
                        <div *ngIf="form.clientType_Id.dirty && form.clientType_Id.errors" class="invalid-feedback">
                          <span *ngIf="form.clientType_Id.errors.required">This value is required.</span>
                        </div>
                      </div>
                    </div>
      
                  </div>
                  <!-- ----------------------------------------------------------------------------- -->
                </div>
              </div>
              <div class="col-md-12">
              <!-- -------------------------------- Form Client Addresses -------------------------------- -->
                <div class="p-2">
                  <!-- <div class="card-header text-center ">
                    {{'GENERAL.PERSONAL_INFORMATION' | translate}}
                  </div> -->
                  <div class="card">
                    <div class="col-12 ">
                      <div class="card-header text-center ">
                        {{'GENERAL.ClientAddresses' | translate}}
                      </div>
                      <div class="card-body mt-3 ">
                        <div class="row" formArrayName="ClientAddresses">
                          <div *ngFor="let ClientAddresse of ClientAddresses.controls; let i = index">
                            <ng-container [formGroupName]="i">
                              <div class="col-12 border-content p-2 my-2">
                                <button type="button" (click)="deleteFormClientAddresses(i)"
                                  class="btn btn-danger d-block ms-auto">X
                                </button>
      
                                <div class="row">
                                  <div class="col-xl-4 col-lg-6">
                                    <div class="mb-3">
                                      <label class="form-label text-capitalize">{{'GENERAL.COUNTRY' |
                                        translate}}</label>
      
                                      <ng-select [items]="ListOfCountries" formControlName="country_Id"
                                        class="form-control ng-select-customization"
                                        (change)="getListOfStates($event?.id , i)" bindLabel="name"
                                        bindValue="id"></ng-select>
                                    </div>
                                  </div>
      
                                  <div class="col-xl-4 col-lg-6">
                                    <div class="mb-3">
                                      <label class="form-label text-capitalize">{{'GENERAL.STATES' |
                                        translate}}</label>
      
                                      <ng-select [items]="ClientAddresses.controls[i].get('listOfStates').value" formControlName="state_Id"
                                        class="form-control ng-select-customization"
                                        (change)="getListOfRegions($event?.id , i)" bindLabel="name"
                                        bindValue="id"></ng-select>
      
                                    </div>
                                  </div>
      
                                  <div class="col-xl-4 col-lg-6">
                                    <div class="mb-3">
                                      <label class="form-label text-capitalize">{{'GENERAL.REGION' |
                                        translate}}</label>
      
                                      <ng-select [items]="ClientAddresses.controls[i].get('listOfRegion').value" formControlName="region_Id"
                                        class="form-control ng-select-customization"
                                        [ngClass]="{'is-valid': ClientAddresse.get('region_Id').dirty && !ClientAddresse.get('region_Id').errors ,'is-invalid': ClientAddresse.get('region_Id').dirty && ClientAddresse.get('region_Id').errors}"
                                        bindLabel="name" bindValue="id"></ng-select>
      
                                      <div
                                        *ngIf="ClientAddresse.get('region_Id').dirty && ClientAddresse.get('region_Id').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="ClientAddresse.get('region_Id').errors.required">This value is
                                          required.</span>
                                      </div>
                                    </div>
                                  </div>
      
                                  <!-- Eng Ahmed Abdelhameed Ali ---- this field deprecated -->
                                  <!-- <div class="col-xl-4 col-lg-6">
                                    <div class="mb-3">
                                      <label for="validationCustom01"
                                        class="form-label text-capitalize">{{'GENERAL.POSTALCODE'
                                        |
                                        translate}} </label>
                                      <input type="text" class="form-control" id="validationCustom01"
                                        formControlName="PostalCode"
                                        [ngClass]="{'is-valid': ClientAddresse.get('PostalCode').dirty && !ClientAddresse.get('PostalCode').errors }">
                                      <div
                                        *ngIf="ClientAddresse.get('PostalCode').dirty && ClientAddresse.get('PostalCode').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="ClientAddresse.get('PostalCode').errors.required">This
                                          value is
                                          required.</span>
                                      </div>
                                    </div>
                                  </div> -->
                                  
                                  <div class="col-xl-12 col-lg-6">
                                    <div class="mb-3">
                                      <label for="validationCustom01" class="form-label text-capitalize">{{'GENERAL.ADDRESS' |
                                        translate}}</label>
                                      <input type="text" class="form-control" id="validationCustom01"
                                        formControlName="addressInDetails"
                                        [ngClass]="{'is-valid': ClientAddresse.get('addressInDetails').dirty && !ClientAddresse.get('addressInDetails').errors ,'is-invalid': ClientAddresse.get('addressInDetails').dirty && ClientAddresse.get('addressInDetails').errors}">
                                      <div
                                        *ngIf="ClientAddresse.get('addressInDetails').dirty && ClientAddresse.get('addressInDetails').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="ClientAddresse.get('addressInDetails').errors.required">This value is
                                          required.</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </ng-container>
                          </div>
                        </div>
                      </div>
                      <!-- Eng Ahmed Abdelhameed Ali ---- this field deprecated -->
                      <div class="m-2" *ngIf="!ClientAddresses.length">
                        <button class="btn btn-outline-success" type="button"
                          (click)="addFormClientAddresses()">{{'GENERAL.ADD'
                          | translate}} <i class="bx bx-plus-medical"></i></button>
                      </div>
                    </div>
                  </div>
                  <!-- ----------------------------------------------------------------------------- -->
                  <!-- <hr> -->
                  <!-- -------------------------------- Form Client Contact Lists -------------------------------- -->
                  <!-- Eng Ahmed Abdelhameed Ali ---- this field deprecated -->
                  <!-- <div class="card">
                    <div class="col-12">
                      <div class="card-header text-center">
                        {{'GENERAL.ClientContactLists' | translate}}
                      </div>
                      <div class="card-body m-0" formArrayName="ClientContactLists">
                        <div *ngFor="let ClientContactList of ClientContactLists.controls; let i = index">
                          <ng-container [formGroupName]="i">
                            <div class="col-12 border-content p-2 my-2">
                              <button type="button" (click)="deleteFormClientContactLists(i)"
                                class="btn btn-danger d-block ms-auto ">X
                              </button>
                              <div class="row">
                                
                                <div class="col-xl-6 col-lg-6">
                                  <div class="mb-3">
                                    <label for="validationCustom01" class="form-label text-capitalize">{{'GENERAL.TELEPHONE'
                                      |
                                      translate}}</label>
                                    <input type="text" class="form-control" id="validationCustom01"
                                      formControlName="Telephone"
                                      [ngClass]="{'is-valid': ClientContactList.get('Telephone').dirty && !ClientContactList.get('Telephone').errors ,'is-invalid': ClientContactList.get('Telephone').dirty && ClientContactList.get('Telephone').errors}">
                                    <div
                                      *ngIf="ClientContactList.get('Telephone').dirty && ClientContactList.get('Telephone').errors"
                                      class="invalid-feedback">
                                      <span *ngIf="ClientContactList.get('Telephone').errors.required">This
                                        value is
                                        required.</span>
                                      <span *ngIf="ClientContactList.get('Telephone').errors.pattern">This
                                        value must be number</span>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-xl-6 col-lg-6">
                                  <div class="mb-3">
                                    <label class="form-label text-capitalize">{{'GENERAL.EMAIL'
                                      |
                                      translate}}</label>
                                    <div>
                                      <input type="email" class="form-control" formControlName="Email"
                                        [ngClass]="{'is-valid': ClientContactList.get('Email').dirty && !ClientContactList.get('Email').errors ,'is-invalid': ClientContactList.get('Email').dirty && ClientContactList.get('Email').errors}" />
                                      <div
                                        *ngIf="ClientContactList.get('Email').dirty && ClientContactList.get('Email').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="ClientContactList.get('Email').errors.required">This
                                          value is
                                          required.</span>
                                        <span *ngIf="ClientContactList.get('Email').errors.Email">This
                                          value should be a
                                          valid Email.</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                      <div class="m-2">
                        <button class="btn btn-outline-success" type="button"
                          (click)="addFormClientContactLists()">{{'GENERAL.ADD' | translate}} <i
                            class="bx bx-plus-medical"></i></button>
                      </div>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
          </form>
        </ng-container>
      </div>
    
</div>
<div class="modal-footer">
</div>